import { gql } from '@apollo/client';

export default gql`
  mutation setInitialActivityLevelForUser($activityLevelUuid: String!) {
    setInitialActivityLevelForUser(activityLevelUuid: $activityLevelUuid)
  }
`;
